(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function setEqualHeight() {
    if (window.innerWidth <= 750) {
      window.requestAnimationFrame(() => {
        document.querySelectorAll('[class*="footer-block--desktop-"]').forEach(block => {
          block.style.height = 'auto';
        });
      });
      return;
    }

    const blocks = [...document.querySelectorAll('[class*="footer-block--desktop-"]')];
    if (blocks.length === 0) return;

    let rows = [];
    let currentRow = [];
    let rowWidth = 0;

    window.requestAnimationFrame(() => {
      blocks.forEach(block => {
        block.style.height = 'auto';
      });
    });

    blocks.forEach(block => {
      const match = block.className.match(/footer-block--desktop-(\d+)/);
      const colSize = match ? parseInt(match[1]) : 0;

      if (rowWidth + colSize > 12) {
        rows.push(currentRow);
        currentRow = [];
        rowWidth = 0;
      }

      currentRow.push(block);
      rowWidth += colSize;
    });

    if (currentRow.length) rows.push(currentRow);

    rows.forEach(row => {
      const maxHeight = Math.max(...row.map(block => block.offsetHeight));
      window.requestAnimationFrame(() => {
        row.forEach(block => {
          block.style.height = `${maxHeight}px`;
        });
      });
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    setTimeout(setEqualHeight, 100);
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setEqualHeight, 100);
  });

  if (Shopify.designMode) {
    const sectionId = "{{ section.id }}";

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.detail.sectionId === sectionId) {
        setTimeout(setEqualHeight, 100);
      }
    });
  
    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId === sectionId) {
        setTimeout(setEqualHeight, 100);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omne-bundle-pdp"]) return;
  try {
    

  /* — Countdown timer (BYOB-style): uses data-end if set, else resets at midnight local — */
  (function initUrgencyTimer() {
    const timers = document.querySelectorAll('[data-timer]');
    if (!timers.length) return;
    timers.forEach(function(timer) {
      const endAttr = timer.getAttribute('data-end');
      function tick() {
        let end;
        if (endAttr) {
          end = new Date(endAttr).getTime();
        } else {
          const d = new Date(); d.setHours(23, 59, 59, 999); end = d.getTime();
        }
        const diff = Math.max(end - Date.now(), 0) / 1000;
        const dd = Math.floor(diff / 86400);
        const hh = Math.floor((diff % 86400) / 3600);
        const mm = Math.floor((diff % 3600) / 60);
        const ss = Math.floor(diff % 60);
        const setT = (k, v) => { const el = timer.querySelector('[data-t="' + k + '"]'); if (el) el.textContent = v; };
        setT('d', dd);
        setT('h', String(hh).padStart(2, '0'));
        setT('m', String(mm).padStart(2, '0'));
        setT('s', String(ss).padStart(2, '0'));
      }
      tick(); setInterval(tick, 1000);
    });
  })();
(function() {
  const section = document.querySelector('.os-bundle');
  if (!section) return;

  const sectionId = section.closest('[id^="shopify-section"]')?.id?.replace('shopify-section-', '') || '';

  /* — Product JSON — */
  const jsonEl = document.getElementById('BundleProductJSON-' + sectionId);
  if (!jsonEl) return;

  let productData;
  try { productData = JSON.parse(jsonEl.textContent); } catch(e) { return; }

  /* — Size selection (pills OR dropdown, depending on bundle config) — */
  const pills = section.querySelectorAll('.os-bundle__size-pill');
  const sizeSelect = section.querySelector('.os-bundle__size-select');
  const bundleDD = section.querySelector('[data-bundle-dd]');
  const atcBtn = document.getElementById('BundleATC-' + sectionId);
  const mainImage = document.getElementById('BundleMainImage-' + sectionId);
  const payNow = document.getElementById('BundlePayNow-' + sectionId);
  const monthly = document.getElementById('BundleMonthly-' + sectionId);
  const tablePrice = document.getElementById('BundleTablePrice-' + sectionId);
  const tableSave = document.getElementById('BundleTableSave-' + sectionId);
  const stickyPrice = document.getElementById('BundleStickyPrice-' + sectionId);
  const stickyBtn = section.querySelector('.os-bundle__sticky-btn');
  const mainPrice = document.getElementById("BundleMainPrice-" + sectionId);
  const comparePrice = document.getElementById("BundleCompare-" + sectionId);
  const savingsBadge = document.getElementById("BundleSavingsBadge-" + sectionId);
  const countdownPcts = section.querySelectorAll("[data-savings-headline]");
  const payCompare = document.getElementById("BundlePayCompare-" + sectionId);
  const tableCompare = document.getElementById("BundleTableCompare-" + sectionId);

  /* — Component product prices for dynamic retail values — */
  const compJsonEl = document.getElementById("BundleComponentPrices-" + sectionId);
  let componentPrices = {};
  try { componentPrices = JSON.parse(compJsonEl?.textContent || "{}"); } catch(e) {}

  const tvEl = document.getElementById("BundleTotalValue-" + sectionId);
  let tvMap = {};
  try { tvMap = JSON.parse(tvEl?.textContent || "{}"); } catch(e) {}
  const componentPriceEls = section.querySelectorAll("[data-component-price]");

  /* Normalize a size token for matching: lowercase, "California"->"Cal",
     strip non-alphanumerics. 'Twin XL'->'twinxl', 'TwinXL'->'twinxl',
     'California King'->'calking', 'Cal King'->'calking'. */
  function normSize(s) {
    return String(s).toLowerCase().replace(/california/g, 'cal').replace(/[^a-z0-9]/g, '');
  }

  function findComponentPrice(handle, sizeTitle) {
    const variants = componentPrices[handle];
    /* Single-variant / flat components (the 2-pack pillow, a $0 multi-height shell, etc.)
       have no real per-size pricing — keep their static retail anchor, never overwrite. */
    if (!variants || variants.length <= 1) return null;

    const target = normSize(sizeTitle);
    /* Exact match on any "/"-separated, normalized part. Matches 'Queen' but not
       'Split Top Queen'; 'King' but not 'Cal King'; and sheets' 'White / Queen'
       via its size part. Junk variants ('1111') never match a real size. */
    for (const v of variants) {
      const parts = String(v.title).split('/').map(normSize);
      if (parts.indexOf(target) !== -1) return v.price;
    }
    /* No clean per-size match — keep the static anchor rather than show a wrong value. */
    return null;
  }

  function updateComponentPrices(sizeTitle) {
    for (const el of componentPriceEls) {
      const handle = el.dataset.componentHandle;
      const price = findComponentPrice(handle, sizeTitle);
      if (price !== null) {
        const label = el.dataset.priceLabel || "Retail: ";
        el.textContent = label + formatMoney(price);
      }
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function updateVariant(variantId) {
    const variant = productData.variants.find(v => v.id === Number(variantId));
    if (!variant) return;

    /* Update URL */
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState(null, '', url.toString());

    /* Update prices */
    const price = variant.price;
    const compare = tvMap[variant.id] || variant.compare_at_price || 0;
    const savings = compare > price ? compare - price : 0;
    const savingsPct = savings > 0 ? Math.round((savings / compare) * 100) : 0;

    if (mainPrice) mainPrice.textContent = formatMoney(price);
    if (payNow) payNow.textContent = formatMoney(price);
    if (monthly) {
      const mo = Math.ceil((price / 100) / 18);
      monthly.textContent = "$" + mo + "/mo";
      section.querySelectorAll('[data-per-mo-inline]').forEach(el => el.textContent = "$" + mo + "/mo");
    }
    if (comparePrice) comparePrice.textContent = "(Total Value: " + formatMoney(compare) + ")";
    if (payCompare) payCompare.textContent = "(Total Value: " + formatMoney(compare) + ")";
    if (tableCompare) tableCompare.textContent = formatMoney(compare);
    if (tablePrice) tablePrice.textContent = formatMoney(price);
    if (tableSave && savings > 0) {
      tableSave.textContent = formatMoney(savings) + " (" + savingsPct + "% off)";
    }
    if (savingsBadge) savingsBadge.textContent = savingsPct + "% SAVINGS";
    if (countdownPcts) countdownPcts.forEach(el => el.textContent = savingsPct + "% Savings");
    if (stickyPrice) stickyPrice.textContent = formatMoney(price);

    /* BYOB-style summary (Total Value / You Save / You Pay) */
    const sumEl = section.querySelector('[data-bundle-summary]');
    if (sumEl) {
      const tvEl2 = sumEl.querySelector('[data-sum-tv]');
      const saveEl = sumEl.querySelector('[data-sum-save]');
      const pctEl = sumEl.querySelector('[data-sum-pct]');
      const payEl = sumEl.querySelector('[data-sum-pay]');
      if (tvEl2) tvEl2.textContent = compare > 0 ? formatMoney(compare) : '';
      if (saveEl) saveEl.textContent = savings > 0 ? formatMoney(savings) : '';
      if (pctEl) pctEl.textContent = savingsPct > 0 ? savingsPct + '% off' : '';
      if (payEl) payEl.textContent = formatMoney(price);
    }

    /* Update ATC */
    if (atcBtn) {
      atcBtn.dataset.variantId = variant.id;
      atcBtn.disabled = !variant.available;
      const atcLabel = atcBtn.dataset.atcLabel || 'Add Complete Bundle to Cart';
      atcBtn.textContent = variant.available ? atcLabel : 'Sold Out';
    }
    if (stickyBtn) {
      stickyBtn.dataset.variantId = variant.id;
    }

    /* Update main image if variant has image */
    if (variant.featured_image && mainImage) {
      const img = mainImage.querySelector('img');
      if (img) {
        img.src = variant.featured_image.src.replace(/(\.[^.]+)$/, '_900x$1');
        img.alt = variant.featured_image.alt || productData.title;
      }
    }

    /* Update pills + dropdown to reflect the active variant */
    for (const pill of pills) {
      pill.classList.toggle('os-bundle__size-pill--active',
        pill.dataset.variantId === String(variant.id));
    }
    if (sizeSelect && sizeSelect.value !== String(variant.id)) {
      sizeSelect.value = String(variant.id);
    }
    /* Reflect on the BYOB-style custom dropdown (copper) */
    if (bundleDD) {
      const lbl = bundleDD.querySelector('[data-dd-label]');
      const prc = bundleDD.querySelector('[data-dd-price]');
      if (lbl) lbl.textContent = variant.title;
      if (prc) prc.textContent = formatMoney(variant.price);
      bundleDD.querySelectorAll('.os-bundle__dd-opt').forEach(o => {
        o.classList.toggle('is-selected', o.dataset.variantId === String(variant.id));
      });
    }
    section.dispatchEvent(new CustomEvent('bundle:sizechange'));

    /* Update component "Retail:" values for the selected size. Single-variant/flat
       components keep their static anchor (see findComponentPrice). */
    updateComponentPrices(variant.title);
  }

  for (const pill of pills) {
    pill.addEventListener('click', () => {
      if (pill.disabled) return;
      updateVariant(pill.dataset.variantId);
    });
  }
  if (sizeSelect) {
    sizeSelect.addEventListener('change', () => updateVariant(sizeSelect.value));
  }

  /* BYOB-style custom dropdown (copper): open/close + select → updateVariant */
  if (bundleDD) {
    const trigger = bundleDD.querySelector('[data-dd-trigger]');
    if (trigger) {
      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        const open = bundleDD.classList.contains('is-open');
        bundleDD.classList.toggle('is-open', !open);
        trigger.setAttribute('aria-expanded', (!open).toString());
      });
    }
    bundleDD.querySelectorAll('.os-bundle__dd-opt').forEach(opt => {
      opt.addEventListener('click', () => {
        if (opt.dataset.available === 'false') return;
        bundleDD.classList.remove('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        updateVariant(opt.dataset.variantId);
      });
    });
    document.addEventListener('click', () => {
      bundleDD.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  /* On load: set component retail values to the initially-selected size so they're
     correct immediately (not just after the first click). */
  (function initComponentPrices() {
    let v = null;
    if (sizeSelect) v = productData.variants.find(x => String(x.id) === sizeSelect.value);
    if (!v && bundleDD) {
      const sel = bundleDD.querySelector('.os-bundle__dd-opt.is-selected');
      if (sel) v = productData.variants.find(x => String(x.id) === sel.dataset.variantId);
    }
    if (!v) {
      const active = section.querySelector('.os-bundle__size-pill--active') || pills[0];
      if (active) v = productData.variants.find(x => String(x.id) === active.dataset.variantId);
    }
    if (v) updateComponentPrices(v.title);
  })();

  /* — Gallery navigation with preloading & smooth transitions — */
  const thumbs = section.querySelectorAll('.os-bundle__thumb');
  const thumbsArr = Array.from(thumbs);
  const navPrev = section.querySelector('.os-bundle__nav--prev');
  const navNext = section.querySelector('.os-bundle__nav--next');
  const mainImg = mainImage?.querySelector('img');
  const imageCache = new Map();

  /* Pick the appropriate image URL based on viewport */
  function getUrlFor(thumb) {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    return (isMobile && thumb.dataset.imageUrlMobile) ? thumb.dataset.imageUrlMobile : thumb.dataset.imageUrl;
  }

  /* Preload every gallery image into the browser cache on page load.
     Uses Image() objects which lets the browser pick WebP via Accept header
     and stores them in HTTP cache so subsequent <img src=...> swaps are instant. */
  function preloadAllImages() {
    if (!('requestIdleCallback' in window)) {
      // Fallback: preload after a short delay
      setTimeout(() => thumbsArr.forEach(t => preloadOne(getUrlFor(t))), 800);
      return;
    }
    requestIdleCallback(() => {
      thumbsArr.forEach((t, i) => {
        // Stagger to avoid bandwidth competition with above-the-fold content
        setTimeout(() => preloadOne(getUrlFor(t)), i * 80);
      });
    }, { timeout: 2000 });
  }

  function preloadOne(url) {
    if (!url || imageCache.has(url)) return;
    const img = new Image();
    img.decoding = 'async';
    img.fetchPriority = 'low';
    imageCache.set(url, img);
    img.src = url;
  }

  /* Swap main image with a fade. Uses Image() so the swap only happens after
     the new image is fully loaded — prevents broken-image flash. */
  let swapToken = 0;
  function swapMainImage(url, alt) {
    if (!mainImg || !url) return;
    if (mainImg.src === url) return;

    const myToken = ++swapToken;
    mainImage.classList.add('os-bundle__main-image--loading');

    const preloader = imageCache.get(url) || new Image();
    if (!imageCache.has(url)) {
      imageCache.set(url, preloader);
      preloader.src = url;
    }

    const apply = () => {
      if (myToken !== swapToken) return; // user clicked again, abort
      // Clear srcset/sizes so the new src actually wins. Without this,
      // the browser keeps using the original srcset URLs regardless of src changes.
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = url;
      if (alt) mainImg.alt = alt;
      // Remove loading state on next frame after image renders
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          mainImage.classList.remove('os-bundle__main-image--loading');
        });
      });
    };

    if (preloader.complete && preloader.naturalWidth > 0) {
      apply();
    } else {
      preloader.addEventListener('load', apply, { once: true });
      preloader.addEventListener('error', () => {
        if (myToken === swapToken) {
          mainImage.classList.remove('os-bundle__main-image--loading');
        }
      }, { once: true });
    }
  }

  /* Thumbnail clicks */
  for (const thumb of thumbs) {
    thumb.addEventListener('click', () => {
      swapMainImage(getUrlFor(thumb), thumb.querySelector('img')?.alt);
      for (const t of thumbs) t.classList.remove('os-bundle__thumb--active');
      thumb.classList.add('os-bundle__thumb--active');
      updateNavState();
    });
  }

  /* Arrow navigation — operates over the currently VISIBLE thumbs only, so the
     mattress filter (hiding non-selected images) cycles within the right set. */
  function visibleThumbs() {
    return thumbsArr.filter(t => !t.classList.contains('is-hidden'));
  }

  function getActiveIndex() {
    const vis = visibleThumbs();
    const activeIdx = vis.findIndex(t => t.classList.contains('os-bundle__thumb--active'));
    return activeIdx === -1 ? 0 : activeIdx;
  }

  function updateNavState() {
    const vis = visibleThumbs();
    if (!navPrev || !navNext || vis.length === 0) return;
    const idx = getActiveIndex();
    navPrev.disabled = idx === 0;
    navNext.disabled = idx === vis.length - 1;
  }

  function navigate(direction) {
    const vis = visibleThumbs();
    if (vis.length === 0) return;
    const currentIdx = getActiveIndex();
    let nextIdx = direction === 'next' ? currentIdx + 1 : currentIdx - 1;
    if (nextIdx < 0 || nextIdx >= vis.length) return;
    vis[nextIdx].click();
  }

  if (navPrev) navPrev.addEventListener('click', () => navigate('prev'));
  if (navNext) navNext.addEventListener('click', () => navigate('next'));

  /* Keyboard support */
  if (mainImage && thumbsArr.length > 1) {
    mainImage.tabIndex = 0;
    mainImage.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); navigate('prev'); }
      if (e.key === 'ArrowRight') { e.preventDefault(); navigate('next'); }
    });
  }

  updateNavState();
  preloadAllImages();

  /* — Mattress selector (optional; scoped via the section's enable setting) —
     Switches the visible gallery set (e.g. Hybrid=imgs 1,2 / MF=imgs 3,4; others
     stay hidden) and records the choice as a line-item property sent on ATC. */
  let selectedMattressValue = null;
  let mattressPropName = 'Mattress';
  const mattressWrap = section.querySelector('.os-bundle__mattress');
  if (mattressWrap) {
    mattressPropName = mattressWrap.dataset.mattressProperty || 'Mattress';
    const doFilter = mattressWrap.dataset.mattressFilter === 'true';
    const mtiles = Array.from(mattressWrap.querySelectorAll('.os-bundle__mtile'));

    const parseIdx = (str) => (str || '').split(',')
      .map(s => parseInt(s.trim(), 10)).filter(n => !isNaN(n));

    function applyMattress(tile, swap) {
      mtiles.forEach(t => {
        const on = t === tile;
        t.classList.toggle('os-bundle__mtile--active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      selectedMattressValue = tile.dataset.mattressValue || null;

      /* Swap the mattress rows (Bundle Includes accordion + What's In This Set) to match the choice */
      const key = tile.dataset.mattressKey === 'b' ? 'b' : 'a';
      const pick = (row, base) => key === 'b' ? row.dataset[base + 'B'] : row.dataset[base + 'A'];
      const fillFeats = (ul, str) => {
        if (!ul) return;
        const items = (str || '').split('|').map(s => s.trim()).filter(Boolean);
        if (!items.length) return;
        const wi = ul.hasAttribute('data-wi-feats');
        ul.innerHTML = items.map(t => wi
          ? '<li><svg width="14" height="14" viewBox="0 0 24 24" fill="#488787"><circle cx="12" cy="12" r="12"/><path d="M7 12l3.5 3.5L17 9" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg> ' + t + '</li>'
          : '<li>' + t + '</li>'
        ).join('');
      };

      /* Bundle Includes accordion mattress row (name + thumbnail + description + features) */
      section.querySelectorAll('[data-includes-mattress]').forEach(row => {
        const name = pick(row, 'name'), icon = pick(row, 'icon');
        const desc = pick(row, 'desc'), feats = pick(row, 'feats');
        const nameEl = row.querySelector('[data-includes-name]');
        const imgEl = row.querySelector('[data-includes-img]');
        const descEl = row.querySelector('[data-includes-desc]');
        const featsEl = row.querySelector('[data-includes-feats]');
        if (nameEl && name) nameEl.textContent = name;
        if (imgEl && icon) { imgEl.src = icon; if (name) imgEl.alt = name; }
        if (descEl && desc) descEl.textContent = desc;
        fillFeats(featsEl, feats);
      });

      /* What's In This Set mattress row (name + image + description + features) */
      section.querySelectorAll('[data-wi-mattress]').forEach(row => {
        const name = pick(row, 'name'), img = pick(row, 'img');
        const desc = pick(row, 'desc'), feats = pick(row, 'feats');
        const nameEl = row.querySelector('[data-wi-name]');
        const imgEl = row.querySelector('[data-wi-img]');
        const descEl = row.querySelector('[data-wi-desc]');
        const featsEl = row.querySelector('[data-wi-feats]');
        if (nameEl && name) nameEl.textContent = name;
        if (imgEl && img) { imgEl.src = img; if (name) imgEl.alt = name; }
        if (descEl && desc) descEl.textContent = desc;
        fillFeats(featsEl, feats);
      });

      if (!doFilter) return;
      const want = parseIdx(tile.dataset.images);
      thumbsArr.forEach(t => {
        const idx = parseInt(t.dataset.imgIndex, 10);
        t.classList.toggle('is-hidden', want.indexOf(idx) === -1);
      });

      const vis = visibleThumbs();
      if (vis.length) {
        const stillActive = vis.find(t => t.classList.contains('os-bundle__thumb--active'));
        const target = stillActive || vis[0];
        thumbs.forEach(t => t.classList.remove('os-bundle__thumb--active'));
        target.classList.add('os-bundle__thumb--active');
        if (swap && !stillActive) swapMainImage(getUrlFor(target), target.querySelector('img')?.alt);
      }
      updateNavState();
    }

    mtiles.forEach(tile => tile.addEventListener('click', () => applyMattress(tile, true)));

    /* Init: honor the server-marked active tile (default = option A) and hide the
       non-selected / excluded images on load without animating a swap. */
    const initTile = mtiles.find(t => t.classList.contains('os-bundle__mtile--active')) || mtiles[0];
    if (initTile) applyMattress(initTile, false);
  }

  /* — Add to Cart (fetch → cart drawer) — */
  async function addToCart(variantId) {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (selectedMattressValue) {
      formData.append('properties[' + mattressPropName + ']', selectedMattressValue);
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      if (!response.ok) throw new Error('Add to cart failed');

      /* Try to open theme cart drawer */
      document.querySelector('cart-drawer')?.open?.();
      document.querySelector('[data-cart-drawer]')?.classList?.add('is-open');
      document.dispatchEvent(new CustomEvent('cart:updated'));

      /* Fallback: refresh cart count in header */
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();
      const countEls = document.querySelectorAll('[data-cart-count], .cart-count-bubble span');
      for (const el of countEls) {
        el.textContent = cartData.item_count;
      }
    } catch (error) {
      console.error('Add to cart error:', error);
    }
  }

  if (atcBtn) {
    atcBtn.addEventListener('click', () => {
      if (atcBtn.disabled) return;
      const origText = atcBtn.textContent;
      atcBtn.textContent = 'Adding...';
      atcBtn.disabled = true;
      addToCart(atcBtn.dataset.variantId).finally(() => {
        setTimeout(() => {
          atcBtn.textContent = origText;
          atcBtn.disabled = false;
        }, 1200);
      });
    });
  }

  if (stickyBtn) {
    stickyBtn.addEventListener('click', () => {
      addToCart(stickyBtn.dataset.variantId);
    });
  }

  /* — Sticky mobile ATC on scroll — */
  const stickyMobile = document.getElementById('BundleStickyMobile-' + sectionId);
  if (stickyMobile && atcBtn) {
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        stickyMobile.classList.toggle('is-visible', !entry.isIntersecting);
      }
    }, { threshold: 0 });
    observer.observe(atcBtn);
  }

  /* — Product Dimensions widget (copper polish): footprint follows the selected
       size, weight is for the included OS5 base. Reads the main size dropdown. — */
  (function initBundleDims() {
    const dimBox = section.querySelector('[data-bundle-dims]');
    const dimDataEl = document.getElementById('BundleDims-' + sectionId);
    if (!dimBox || !dimDataEl) return;
    let DIM = null;
    try { DIM = JSON.parse(dimDataEl.textContent); } catch (e) { return; }
    const dEl = dimBox.querySelector('[data-dim-dims]');
    const wEl = dimBox.querySelector('[data-dim-weight]');
    const cEl = dimBox.querySelector('[data-dim-clear]');

    function currentTitle() {
      let vid = sizeSelect ? sizeSelect.value : null;
      if (!vid && bundleDD) {
        const sel = bundleDD.querySelector('.os-bundle__dd-opt.is-selected');
        if (sel) vid = sel.dataset.variantId;
      }
      if (!vid && productData && productData.variants && productData.variants[0]) {
        vid = String(productData.variants[0].id);
      }
      if (productData && productData.variants) {
        const v = productData.variants.find(x => String(x.id) === String(vid));
        if (v) return v.title;
      }
      return null;
    }
    function renderDims() {
      const t = currentTitle();
      const f = (t && DIM.foot) ? DIM.foot[t] : null;
      const w = (t && DIM.weight) ? DIM.weight[t] : null;
      if (dEl) dEl.textContent = f ? (f.w + '" (W) \u00d7 ' + f.l + '" (L) \u00d7 ' + DIM.height + ' (H)') : '\u2014';
      if (wEl) wEl.textContent = (w != null) ? (w + ' lbs') : '\u2014';
      if (cEl) cEl.textContent = DIM.clearance || '\u2014';
    }
    if (sizeSelect) sizeSelect.addEventListener('change', renderDims);
    section.addEventListener('bundle:sizechange', renderDims);
    renderDims();
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omne-sleep-pdp"] && !Shopify.designMode) return;
  try {
    
class OsSleepPdp extends HTMLElement {
  connectedCallback() {
    this.productData = null;
    this.selectedOptions = {};
    this.beddingActive = false;
    this.#init();
  }
  async #init() {
    const url = this.dataset.productUrl;
    if (url) { try { const r = await fetch(url); if (r.ok) this.productData = await r.json(); } catch(e){} }
    this.#initSelected();
    this.#bindThumbs();
    this.#bindDropdowns();
    this.#bindAddon();
    this.#bindBases();
    this.#bindBeddingPanel();
    this.#bindAtc();
    this.#bindTabs();
    this.#bindStickyAtc();
    this.#updateSecondaryPrices();
    this.#updateBeddingPricing();
    this.#initStickyInfo();
  }
  #initStickyInfo() {
    if (window.innerWidth < 900) return;
    const info = this.querySelector('.os-pdp__info');
    if (!info) return;
    const setTop = () => {
      const infoH = info.getBoundingClientRect().height;
      const vh = window.innerHeight;
      if (infoH > vh) {
        info.style.top = -(infoH - vh + 20) + 'px';
      } else {
        info.style.top = '20px';
      }
    };
    setTop();
    const ro = new ResizeObserver(setTop);
    ro.observe(info);
    window.addEventListener('resize', setTop);
  }
  #initSelected() {
    if (!this.productData) return;
    for (const row of this.querySelectorAll('.os-pdp__dropdown-row--selected')) {
      this.selectedOptions[row.dataset.optionPosition] = row.dataset.optionValue;
    }
  }
  #bindThumbs() {
    this.galleryMain = this.querySelector('.os-pdp__gallery-main');
    this.mainImg = this.querySelector('.os-pdp__main-image');
    this.thumbsArr = Array.from(this.querySelectorAll('.os-pdp__thumb'));
    this.navPrev = this.querySelector('.os-pdp__nav--prev');
    this.navNext = this.querySelector('.os-pdp__nav--next');
    this.imageCache = new Map();
    this.swapToken = 0;

    const getUrlFor = (t) => {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      return (isMobile && t.dataset.imageSrcMobile) ? t.dataset.imageSrcMobile : t.dataset.imageSrc;
    };

    const preloadOne = (url) => {
      if (!url || this.imageCache.has(url)) return;
      const img = new Image();
      img.decoding = 'async';
      img.fetchPriority = 'low';
      this.imageCache.set(url, img);
      img.src = url;
    };

    const preloadAll = () => {
      const run = () => this.thumbsArr.forEach((t, i) => setTimeout(() => preloadOne(getUrlFor(t)), i * 80));
      if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 2000 });
      else setTimeout(run, 800);
    };

    const swapMainImage = (url, alt) => {
      if (!this.mainImg || !url) return;
      if (this.mainImg.src === url) return;
      const myToken = ++this.swapToken;
      this.galleryMain.classList.add('os-pdp__gallery-main--loading');

      let preloader = this.imageCache.get(url);
      if (!preloader) {
        preloader = new Image();
        this.imageCache.set(url, preloader);
        preloader.src = url;
      }

      const apply = () => {
        if (myToken !== this.swapToken) return;
        this.mainImg.removeAttribute('srcset');
        this.mainImg.removeAttribute('sizes');
        this.mainImg.src = url;
        if (alt) this.mainImg.alt = alt;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          this.galleryMain.classList.remove('os-pdp__gallery-main--loading');
        }));
      };

      if (preloader.complete && preloader.naturalWidth > 0) apply();
      else {
        preloader.addEventListener('load', apply, { once: true });
        preloader.addEventListener('error', () => {
          if (myToken === this.swapToken) this.galleryMain.classList.remove('os-pdp__gallery-main--loading');
        }, { once: true });
      }
    };

    const getActiveIndex = () => {
      const idx = this.thumbsArr.findIndex(t => t.classList.contains('os-pdp__thumb--active'));
      return idx === -1 ? 0 : idx;
    };

    const updateNavState = () => {
      if (!this.navPrev || !this.navNext || this.thumbsArr.length === 0) return;
      const idx = getActiveIndex();
      this.navPrev.disabled = idx === 0;
      this.navNext.disabled = idx === this.thumbsArr.length - 1;
    };

    const navigate = (direction) => {
      if (this.thumbsArr.length === 0) return;
      const currentIdx = getActiveIndex();
      const nextIdx = direction === 'next' ? currentIdx + 1 : currentIdx - 1;
      if (nextIdx < 0 || nextIdx >= this.thumbsArr.length) return;
      this.thumbsArr[nextIdx].click();
    };

    for (const t of this.thumbsArr) {
      t.addEventListener('click', () => {
        for (const s of this.thumbsArr) s.classList.remove('os-pdp__thumb--active');
        t.classList.add('os-pdp__thumb--active');
        swapMainImage(getUrlFor(t), this.mainImg?.alt);
        updateNavState();
      });
    }

    if (this.navPrev) this.navPrev.addEventListener('click', () => navigate('prev'));
    if (this.navNext) this.navNext.addEventListener('click', () => navigate('next'));

    if (this.galleryMain && this.thumbsArr.length > 1) {
      this.galleryMain.tabIndex = 0;
      this.galleryMain.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); navigate('prev'); }
        if (e.key === 'ArrowRight') { e.preventDefault(); navigate('next'); }
      });
    }

    updateNavState();
    preloadAll();
  }
  #bindDropdowns() {
    for (const row of this.querySelectorAll('.os-pdp__dropdown-row')) {
      row.addEventListener('click', () => {
        const dd = row.closest('.os-pdp__dropdown');
        const isCollapsed = dd.classList.contains('os-pdp__dropdown--collapsed');
        if (isCollapsed && row.classList.contains('os-pdp__dropdown-row--selected')) {
          dd.classList.remove('os-pdp__dropdown--collapsed');
          return;
        }
        const pos = row.dataset.optionPosition;
        this.selectedOptions[pos] = row.dataset.optionValue;
        const siblings = dd.querySelectorAll('.os-pdp__dropdown-row');
        for (const s of siblings) { s.classList.remove('os-pdp__dropdown-row--selected'); s.setAttribute('aria-pressed','false'); }
        row.classList.add('os-pdp__dropdown-row--selected');
        row.setAttribute('aria-pressed','true');
        dd.classList.add('os-pdp__dropdown--collapsed');
        this.#updateVariant();
        if (pos === '1') this.#updateSecondaryPrices();
      });
    }
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.os-pdp__dropdown')) {
        for (const dd of this.querySelectorAll('.os-pdp__dropdown')) dd.classList.add('os-pdp__dropdown--collapsed');
      }
    });
  }
  #updateVariant() {
    if (!this.productData) return;
    const vals = Object.keys(this.selectedOptions).sort().map(k => this.selectedOptions[k]);
    const v = this.productData.variants.find(vr => vals.every((val,i) => vr.options[i] === val));
    if (!v) return;
    const idInput = this.querySelector('[data-variant-id]');
    const atc = this.querySelector('.os-pdp__atc');
    const affirm = this.querySelector('[data-affirm-price]');
    if (idInput) idInput.value = v.id;
    if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? 'Add to Cart' : 'Sold Out'; }
    if (affirm) affirm.textContent = '$' + Math.ceil(v.price / 100 / 12) + '/mo';
    const heightRow = this.querySelector('[data-dropdown="height"] .os-pdp__dropdown-row--selected .os-pdp__dropdown-price');
    if (heightRow) heightRow.textContent = '$' + (v.price/100).toFixed(2);
    const stickyPrice = this.querySelector('[data-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = '$' + (v.price/100).toFixed(2);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    history.replaceState(null, '', url.toString());
    this.#renderBundlePricing();
  }
  #updateSecondaryPrices() {
    if (!this.productData) return;
    const opt1 = this.selectedOptions['1'];
    if (!opt1) return;
    // Update all non-first-option dropdowns
    for (const dd of this.querySelectorAll('.os-pdp__dropdown')) {
      const pos = dd.dataset.optionPosition;
      if (pos === '1') continue;
      for (const row of dd.querySelectorAll('.os-pdp__dropdown-row')) {
        const val = row.dataset.optionValue;
        const vr = this.productData.variants.find(v => v.option1 === opt1 && v.options[parseInt(pos)-1] === val);
        const priceEl = row.querySelector('[data-opt-price]') || row.querySelector('.os-pdp__dropdown-price');
        if (vr) {
          if (priceEl) priceEl.textContent = '$' + (vr.price/100).toFixed(2);
          row.style.display = '';
          row.disabled = false;
        } else {
          row.style.display = 'none';
        }
      }
      // If the currently selected option in this dropdown got hidden, select the first visible one
      const selected = dd.querySelector('.os-pdp__dropdown-row--selected');
      if (selected && selected.style.display === 'none') {
        const firstVisible = dd.querySelector('.os-pdp__dropdown-row:not([style*="display: none"])');
        if (firstVisible) {
          selected.classList.remove('os-pdp__dropdown-row--selected');
          selected.setAttribute('aria-pressed','false');
          firstVisible.classList.add('os-pdp__dropdown-row--selected');
          firstVisible.setAttribute('aria-pressed','true');
          this.selectedOptions[pos] = firstVisible.dataset.optionValue;
          this.#updateVariant();
        }
      }
    }
  }
  #bindAddon() {
    const header = this.querySelector('[data-addon-header="bedding"]');
    if (!header) return;
    header.addEventListener('click', () => {
      this.beddingActive = !this.beddingActive;
      const addon = this.querySelector('[data-addon="bedding"]');
      const toggle = this.querySelector('[data-addon-toggle="bedding"]');
      if (toggle) toggle.setAttribute('aria-checked', this.beddingActive ? 'true' : 'false');
      if (addon) addon.classList.toggle('os-pdp__addon--active', this.beddingActive);
    });
  }
  #updateBeddingPricing() {
    const bundleHandle = this.dataset.beddingBundle;
    if (!bundleHandle) return;
    fetch('/products/' + bundleHandle + '.js')
      .then(r => r.ok ? r.json() : null)
      .then(bData => {
        if (!bData) return;
        this._bundleData = bData;
        this.#renderBundlePricing();
      }).catch(() => {});
  }
  #renderBundlePricing() {
    if (!this._bundleData) return;
    const wasEl = this.querySelector('[data-bedding-was]');
    const nowEl = this.querySelector('[data-bedding-now]');
    const panelWas = this.querySelector('[data-panel-was]');
    const panelNow = this.querySelector('[data-panel-now]');
    const selectedSize = this.selectedOptions['1'] || '';
    const matched = this._bundleData.variants.find(v => v.option1 === selectedSize) || this._bundleData.variants[0];
    if (matched) {
      const now = '$' + (matched.price / 100).toFixed(0);
      const was = matched.compare_at_price ? '$' + (matched.compare_at_price / 100).toFixed(0) : '';
      if (wasEl) wasEl.textContent = was;
      if (nowEl) nowEl.textContent = now;
      if (panelWas) panelWas.textContent = was;
      if (panelNow) panelNow.textContent = now;
    }
  }
  #bindStickyAtc() {
    const sticky = this.querySelector('[data-sticky-atc]');
    const hero = this.querySelector('.os-pdp__hero');
    const stickyBtn = this.querySelector('[data-sticky-atc-btn]');
    const mainAtc = this.querySelector('.os-pdp__atc');
    if (!sticky || !hero) return;

    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        sticky.classList.toggle('os-pdp__sticky-atc--visible', !entry.isIntersecting);
      }
    }, { threshold: 0 });
    observer.observe(mainAtc || hero);

    if (stickyBtn && mainAtc) {
      stickyBtn.addEventListener('click', () => mainAtc.click());
    }
  }
  #bindTabs() {
    const tabs = this.querySelectorAll('.os-pdp__tab');
    const panels = this.querySelectorAll('.os-pdp__tab-content');
    for (const tab of tabs) {
      tab.addEventListener('click', () => {
        for (const t of tabs) { t.classList.remove('os-pdp__tab--active'); t.setAttribute('aria-selected','false'); t.tabIndex = -1; }
        tab.classList.add('os-pdp__tab--active'); tab.setAttribute('aria-selected','true'); tab.tabIndex = 0;
        for (const p of panels) p.hidden = true;
        const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = false;
      });
    }
  }
  #bindBeddingPanel() {
    const panel = this.querySelector('[data-bedding-panel]');
    const overlay = this.querySelector('[data-bedding-overlay]');
    if (!panel || !overlay) return;
    const open = () => { panel.classList.add('os-pdp__bedding-panel--open'); overlay.classList.add('os-pdp__bedding-panel-overlay--open'); document.body.style.overflow = 'hidden'; };
    const close = () => { panel.classList.remove('os-pdp__bedding-panel--open'); overlay.classList.remove('os-pdp__bedding-panel-overlay--open'); document.body.style.overflow = ''; };
    for (const img of this.querySelectorAll('[data-addon-products="bedding"] .os-pdp__addon-product img')) {
      img.addEventListener('click', (e) => { e.stopPropagation(); open(); });
    }
    const closeBtn = this.querySelector('[data-bedding-panel-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', close);
    const panelWas = panel.querySelector('[data-panel-was]');
    const panelNow = panel.querySelector('[data-panel-now]');
    const mainWas = this.querySelector('[data-bedding-was]');
    const mainNow = this.querySelector('[data-bedding-now]');
    if (panelWas && mainWas) panelWas.textContent = mainWas.textContent;
    if (panelNow && mainNow) panelNow.textContent = mainNow.textContent;
    const addBtn = panel.querySelector('[data-bedding-panel-add]');
    if (addBtn) {
      addBtn.addEventListener('click', () => {
        const toggle = this.querySelector('[data-addon-toggle="bedding"]');
        if (toggle && toggle.getAttribute('aria-checked') !== 'true') {
          this.querySelector('[data-addon-header="bedding"]')?.click();
        }
        close();
      });
    }
  }
  #bindAtc() {
    const form = this.querySelector('#OsProductForm');
    if (!form) return;
    
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const atcBtn = this.querySelector('.os-pdp__atc');
      if (!atcBtn || atcBtn.disabled) return;
      
      const origText = atcBtn.textContent;
      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding...';
      
      try {
        const items = [];
        
        // Main product
        const variantId = this.querySelector('[data-variant-id]')?.value;
        if (variantId) items.push({ id: parseInt(variantId), quantity: 1 });
        
        // Bedding bundle if toggled on — add single bundle product matched to mattress size
        const beddingToggle = this.querySelector('[data-addon-toggle="bedding"]');
        if (beddingToggle && beddingToggle.getAttribute('aria-checked') === 'true') {
          const bundleHandle = this.dataset.beddingBundle;
          if (bundleHandle && this._bundleData) {
            const selectedSize = this.selectedOptions['1'] || '';
            const matched = this._bundleData.variants.find(v => v.option1 === selectedSize) || this._bundleData.variants[0];
            if (matched) items.push({ id: matched.id, quantity: 1 });
          }
        }
        
        // Add all items — include sections param so Shopify returns rendered drawer HTML
        const cartDrawer = document.querySelector('cart-drawer');
        const sectionsParam = cartDrawer ? 'cart-drawer,cart-icon-bubble' : '';
        
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items, sections: sectionsParam })
        });
        
        if (!resp.ok) throw new Error('Failed');
        const addData = await resp.json();
        
        atcBtn.textContent = 'Added!';
        
        // Use the theme's native renderContents to refresh + open the drawer
        if (cartDrawer && cartDrawer.renderContents && addData.sections) {
          cartDrawer.renderContents({ sections: addData.sections, id: items[0]?.id });
        } else if (cartDrawer) {
          // Fallback: fetch section HTML separately then inject
          try {
            const sectionResp = await fetch('/?sections=cart-drawer,cart-icon-bubble');
            if (sectionResp.ok) {
              const sections = await sectionResp.json();
              cartDrawer.renderContents({ sections: sections, id: items[0]?.id });
            } else {
              cartDrawer.open ? cartDrawer.open() : cartDrawer.classList.add('animate', 'active');
            }
          } catch(e) {
            cartDrawer.open ? cartDrawer.open() : cartDrawer.classList.add('animate', 'active');
          }
        }
        
        // Update cart count in header as backup
        try {
          const cartResp = await fetch('/cart.js');
          const cartData = await cartResp.json();
          const countEls = document.querySelectorAll('.cart-count-bubble span, .cart__count, [data-cart-count]');
          for (const el of countEls) el.textContent = cartData.item_count;
        } catch(err) {}
        
        setTimeout(() => { atcBtn.textContent = origText; atcBtn.disabled = false; }, 2000);
        
      } catch(err) {
        console.error('Add to cart error:', err);
        atcBtn.textContent = origText;
        atcBtn.disabled = false;
      }
    });
  }
  #bindBases() {
    for (const btn of this.querySelectorAll('[data-base-add]')) {
      btn.addEventListener('click', async () => {
        const orig = btn.textContent; btn.disabled = true; btn.textContent = 'Adding...';
        try {
          const cartDrawer = document.querySelector('cart-drawer');
          const body = { items: [{ id: parseInt(btn.dataset.baseAdd), quantity: 1 }] };
          if (cartDrawer) body.sections = 'cart-drawer,cart-icon-bubble';
          const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
          });
          if (!r.ok) throw 0;
          const addData = await r.json();
          btn.textContent = 'Added!';
          if (cartDrawer && cartDrawer.renderContents && addData.sections) {
            cartDrawer.renderContents({ sections: addData.sections, id: parseInt(btn.dataset.baseAdd) });
          } else if (cartDrawer) {
            cartDrawer.open ? cartDrawer.open() : cartDrawer.classList.add('animate', 'active');
          }
          setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 2000);
        } catch(e) { btn.textContent = orig; btn.disabled = false; }
      });
    }
  }
}
customElements.define('os-sleep-pdp', OsSleepPdp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle"] && !Shopify.designMode) return;
  try {
    
  /* ================================================================
     BUNDLE GALLERY — thumbnail switching
     ================================================================ */
  class BundleGallery extends HTMLElement {
    connectedCallback() {
      this.mainImageWrap = this.querySelector('.bundle-gallery__main');
      this.mainImage = this.querySelector('.bundle-gallery__main img');
      this.thumbs = this.querySelectorAll('.bundle-gallery__thumb');
      this.thumbsArr = Array.from(this.thumbs);
      this.navPrev = this.querySelector('.bundle-gallery__nav--prev');
      this.navNext = this.querySelector('.bundle-gallery__nav--next');
      this.imageCache = new Map();
      this.swapToken = 0;

      for (const thumb of this.thumbs) {
        thumb.addEventListener('click', this.#handleThumbClick.bind(this));
      }
      if (this.navPrev) this.navPrev.addEventListener('click', () => this.#navigate('prev'));
      if (this.navNext) this.navNext.addEventListener('click', () => this.#navigate('next'));

      if (this.mainImageWrap && this.thumbsArr.length > 1) {
        this.mainImageWrap.tabIndex = 0;
        this.mainImageWrap.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.#navigate('prev'); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.#navigate('next'); }
        });
      }

      this.#updateNavState();
      this.#preloadAll();
    }

    #getUrlFor(thumb) {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      return (isMobile && thumb.dataset.imageUrlMobile) ? thumb.dataset.imageUrlMobile : thumb.dataset.imageUrl;
    }

    #preloadOne(url) {
      if (!url || this.imageCache.has(url)) return;
      const img = new Image();
      img.decoding = 'async';
      img.fetchPriority = 'low';
      this.imageCache.set(url, img);
      img.src = url;
    }

    #preloadAll() {
      const run = () => this.thumbsArr.forEach((t, i) => setTimeout(() => this.#preloadOne(this.#getUrlFor(t)), i * 80));
      if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 2000 });
      else setTimeout(run, 800);
    }

    #swapMainImage(url, alt) {
      if (!this.mainImage || !url) return;
      if (this.mainImage.src === url) return;
      const myToken = ++this.swapToken;
      this.mainImageWrap.classList.add('bundle-gallery__main--loading');

      let preloader = this.imageCache.get(url);
      if (!preloader) {
        preloader = new Image();
        this.imageCache.set(url, preloader);
        preloader.src = url;
      }

      const apply = () => {
        if (myToken !== this.swapToken) return;
        this.mainImage.removeAttribute('srcset');
        this.mainImage.removeAttribute('sizes');
        this.mainImage.src = url;
        if (alt) this.mainImage.alt = alt;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          this.mainImageWrap.classList.remove('bundle-gallery__main--loading');
        }));
      };

      if (preloader.complete && preloader.naturalWidth > 0) apply();
      else {
        preloader.addEventListener('load', apply, { once: true });
        preloader.addEventListener('error', () => {
          if (myToken === this.swapToken) this.mainImageWrap.classList.remove('bundle-gallery__main--loading');
        }, { once: true });
      }
    }

    #handleThumbClick(event) {
      const thumb = event.currentTarget;
      const url = this.#getUrlFor(thumb);
      const alt = thumb.dataset.imageAlt;

      this.#swapMainImage(url, alt);

      for (const t of this.thumbs) {
        t.classList.remove('bundle-gallery__thumb--active');
        t.setAttribute('aria-current', 'false');
      }
      thumb.classList.add('bundle-gallery__thumb--active');
      thumb.setAttribute('aria-current', 'true');
      this.#updateNavState();
    }

    #getActiveIndex() {
      const idx = this.thumbsArr.findIndex(t => t.classList.contains('bundle-gallery__thumb--active'));
      return idx === -1 ? 0 : idx;
    }

    #updateNavState() {
      if (!this.navPrev || !this.navNext || this.thumbsArr.length === 0) return;
      const idx = this.#getActiveIndex();
      this.navPrev.disabled = idx === 0;
      this.navNext.disabled = idx === this.thumbsArr.length - 1;
    }

    #navigate(direction) {
      if (this.thumbsArr.length === 0) return;
      const currentIdx = this.#getActiveIndex();
      const nextIdx = direction === 'next' ? currentIdx + 1 : currentIdx - 1;
      if (nextIdx < 0 || nextIdx >= this.thumbsArr.length) return;
      this.thumbsArr[nextIdx].click();
    }
  }

  customElements.define('bundle-gallery', BundleGallery);

  /* ================================================================
     SIZE SELECTOR — variant switching
     ================================================================ */
  document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('BundleForm');
    if (!form) return;

    const sizeButtons = form.querySelectorAll('.bundle-form__size');
    const variantInput = form.querySelector('[name="id"]');
    const submitBtn = form.querySelector('.bundle-form__submit');
    const priceEl = document.querySelector('.bundle-hero__price');
    const compareEl = document.querySelector('.bundle-hero__compare');
    const savingsEl = document.querySelector('.bundle-hero__savings');
    const badgeEl = document.querySelector('.bundle-hero__badge');
    const pricingWrapper = document.querySelector('.bundle-hero__pricing');

    const formatMoney = (cents) => {
      const dollars = (cents / 100).toFixed(2);
      return '$' + dollars.replace(/\.00$/, '');
    };

    for (const btn of sizeButtons) {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;

        const variantId = btn.dataset.variantId;
        const price = parseInt(btn.dataset.variantPrice, 10);
        const compare = parseInt(btn.dataset.variantCompare, 10);
        const available = btn.dataset.variantAvailable === 'true';

        /* Update hidden input */
        variantInput.value = variantId;

        /* Update size button states */
        for (const b of sizeButtons) {
          b.classList.remove('bundle-form__size--selected');
          b.setAttribute('aria-checked', 'false');
        }
        btn.classList.add('bundle-form__size--selected');
        btn.setAttribute('aria-checked', 'true');

        /* Update prices */
        if (priceEl) priceEl.textContent = formatMoney(price);
        if (compare && compare > price) {
          const saved = compare - price;
          const pct = Math.round((saved / compare) * 100);
          if (compareEl) {
            compareEl.textContent = formatMoney(compare);
            compareEl.hidden = false;
          }
          if (savingsEl) {
            savingsEl.textContent = 'You save ' + formatMoney(saved);
            savingsEl.hidden = false;
          }
          if (badgeEl) {
            badgeEl.textContent = 'Save ' + pct + '%';
            badgeEl.hidden = false;
          }
          if (pricingWrapper) {
            pricingWrapper.setAttribute('aria-label',
              'Bundle price ' + formatMoney(price) +
              ', originally ' + formatMoney(compare) +
              ', you save ' + formatMoney(saved)
            );
          }
        } else {
          if (compareEl) compareEl.hidden = true;
          if (savingsEl) savingsEl.hidden = true;
          if (badgeEl) badgeEl.hidden = true;
        }

        /* Update submit button */
        if (available) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Add Complete Bundle to Cart';
        } else {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Sold Out';
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
